const {
  Config,
} = require(`weflow_configs/${process.env.REACT_APP_PROJECT_NAME}/details/DetailsConfig.js`);
const detailsConfig = (mapper) => Config(mapper);
export default detailsConfig;
